export default "__VITE_ASSET__lrDZkJYo__"